var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.play}},[_vm._v("11231")]),_vm._v(" "),_c('audio',{ref:"audio",attrs:{"loop":"","src":"http://cdn.cbcnt.com/etop/audio/1421320210409/7a11912aeef84c59b4a16fcd34860d32.mp3"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-393ee302","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/jyq/AudioInfoPage.vue
// module id = null
// module chunks = 